import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fourfiveseaterbusonrentinpune() {



  const cardData =
  {
    keyword: '45 Seater Bus On Rent in Pune',
    heading: 'Amruta Travels: 45 Seater Bus On Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides 45 Seater Bus on Rent in Pune, ideal for large groups looking for a safe, comfortable, and convenient travel experience. Perfect for corporate events, school and college trips, wedding transportation, and long-distance tours, our 45-seater buses come equipped with reclining seats, powerful air conditioning, and ample legroom to ensure a relaxing journey for every passenger. Each bus is maintained in excellent condition and driven by skilled, professional chauffeurs committed to punctuality and safety. Whether it’s a local trip within Pune or an outstation journey to destinations like Goa, Shirdi, or Lonavala, Amruta Travels’ 45 Seater Bus Rental in Pune delivers reliable, luxurious, and cost-effective group travel for all occasions.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



     "services": [
    {
      "name": "45 Seater Bus On Rent in Pune",
      "description": "45 Seater Bus On Rent in Pune offers spacious and well-maintained buses perfect for large groups requiring reliable transport across the city and surrounding regions. Ideal for family trips, corporate outings, school tours, and social events, these buses provide comfortable seating and generous luggage space to accommodate all passengers with ease. Experienced drivers ensure timely pickups, safe driving, and courteous service, making your group travel experience smooth and stress-free throughout Pune and beyond."
    },
    {
      "name": "45 Seater AC Bus Pune",
      "description": "45 Seater AC Bus Pune guarantees a comfortable and cool journey with fully air-conditioned buses designed to beat Pune’s warm climate. Equipped with clean, spacious interiors and ergonomically designed seating, these buses are ideal for long-distance travel, corporate transportation, and leisure tours. The service includes trained, professional drivers committed to passenger comfort, punctuality, and safety, ensuring a pleasant travel experience even during peak summer months."
    },
    {
      "name": "45 Seater Non AC Bus Pune",
      "description": "45 Seater Non AC Bus Pune offers budget-friendly group transportation without compromising on comfort and safety. These non-AC buses are well-maintained, clean, and regularly serviced to provide a smooth ride for city commutes, school trips, and local events. Perfect for short-distance travel and budget-conscious groups, this service ensures dependable transport solutions with professional drivers who prioritize passenger well-being and timely arrivals."
    },
    {
      "name": "45 Seater Luxury Bus Pune",
      "description": "45 Seater Luxury Bus Pune caters to those seeking an upscale travel experience with buses featuring plush seating, modern amenities, and stylish interiors. Perfect for weddings, VIP corporate events, and exclusive group outings, these luxury buses come equipped with entertainment systems, Wi-Fi connectivity, and refreshments to enhance the journey. Courteous and discreet chauffeurs provide impeccable service, ensuring that every ride is comfortable, elegant, and memorable."
    },
    {
      "name": "45 Seater Bus Hire Pune",
      "description": "45 Seater Bus Hire Pune specializes in flexible and reliable bus rental services tailored to meet the diverse needs of Pune’s residents and businesses. Whether you need transport for corporate events, family gatherings, school trips, or social functions, these buses offer spacious interiors, ample luggage storage, and professional drivers with deep knowledge of local routes. The service emphasizes punctuality, safety, and customer satisfaction for a hassle-free group travel experience."
    },
    {
      "name": "45 Seater Bus Rental Pune",
      "description": "45 Seater Bus Rental Pune provides an extensive fleet of buses that undergo regular maintenance and safety checks to ensure dependable transport for groups of varying sizes. This service offers flexible rental durations suitable for short city trips or longer outstation journeys. Transparent pricing, professional drivers, and dedicated customer support combine to create an accessible and convenient rental option for all group travel requirements."
    },
    {
      "name": "45 Seater Bus Hire in Baner",
      "description": "45 Seater Bus Hire in Baner caters to the specific transportation needs of Baner’s residents and businesses, offering well-maintained buses and experienced drivers. Whether for family outings, corporate events, or school trips, this service guarantees punctual pickups and drop-offs with flexible booking options to accommodate any schedule. The focus on vehicle cleanliness, safety, and professionalism ensures reliable and comfortable group travel."
    },
    {
      "name": "45 Seater Bus Hire in Hinjewadi",
      "description": "45 Seater Bus Hire in Hinjewadi serves the bustling IT and corporate sector with efficient and comfortable group transport solutions. These buses are popular among companies and employee groups for daily commutes, client meetings, and corporate outings. The service prioritizes on-time pickups, clean and spacious interiors, and drivers knowledgeable about local traffic conditions, ensuring smooth, stress-free travel for all clients."
    },
    {
      "name": "45 Seater Bus Hire in Pimpri",
      "description": "45 Seater Bus Hire in Pimpri offers reliable and affordable transport options for large groups including employees, social groups, and business travelers. These buses come equipped with comfortable seating and adequate storage for luggage, backed by professional drivers focused on safety and timely service. The service features flexible rental packages suitable for both short-term and extended travel needs, making it a preferred choice in the Pimpri area."
    },
    {
      "name": "45 Seater Bus Hire in Hadapsar",
      "description": "45 Seater Bus Hire in Hadapsar is dedicated to serving the local community and businesses with dependable and well-maintained buses. This service supports a variety of travel requirements such as office commutes, social functions, and airport transfers. Customers benefit from flexible booking options, punctual drivers, and vehicles that meet high standards of cleanliness and safety, ensuring a pleasant travel experience."
    },
    {
      "name": "45 Seater Bus for Wedding Pune",
      "description": "45 Seater Bus for Wedding Pune specializes in providing elegant and spacious buses for wedding events and related ceremonies. This service offers customized decoration options, timely pickups, and experienced chauffeurs who understand the importance of smooth event logistics. The focus is on delivering a luxurious and memorable travel experience, ensuring that wedding guests arrive comfortably and on schedule."
    },
    {
      "name": "45 Seater Bus for Corporate Pune",
      "description": "45 Seater Bus for Corporate Pune delivers professional and reliable transportation tailored for corporate events, employee shuttles, and client visits. These buses feature clean interiors, ample seating, and modern amenities suitable for business travel. With punctual drivers trained in professionalism and discretion, this service supports efficient corporate logistics with flexible booking and transparent pricing."
    },
    {
      "name": "45 Seater Bus for School Tour Pune",
      "description": "45 Seater Bus for School Tour Pune provides safe and dependable transportation for educational outings, excursions, and sports events. These buses come equipped with safety features, comfortable seating, and experienced drivers trained to ensure the wellbeing of students throughout the journey. The service offers flexible scheduling and competitive rates tailored specifically for schools and educational institutions."
    },
    {
      "name": "45 Seater Volvo Bus Pune",
      "description": "45 Seater Volvo Bus Pune offers premium Volvo buses known for their superior comfort, smooth rides, and advanced safety features. Ideal for long-distance travel, corporate events, and luxury tours, these buses provide plush seating, air conditioning, and state-of-the-art suspension systems. Professional drivers ensure punctuality and a first-class travel experience that meets the highest standards of passenger comfort and safety."
    },
    {
      "name": "45 Seater Tourist Coach Pune",
      "description": "45 Seater Tourist Coach Pune specializes in providing buses tailored for sightseeing, group tours, and leisure travel around Pune and nearby tourist destinations. These coaches offer spacious seating, ample luggage space, and knowledgeable drivers who can act as local guides. The service ensures a relaxing and informative journey for tourists, combining comfort with convenience and expert route planning."
    },
    {
      "name": "45 Seater Bus Hire near Me Pune",
      "description": "45 Seater Bus Hire near Me Pune ensures rapid and localized availability of buses throughout Pune, catering to both immediate and advance group travel needs. This service features prompt response times, well-maintained vehicles, and professional drivers dedicated to providing safe, comfortable, and hassle-free transportation. It is designed to make group travel accessible and convenient anywhere in the city."
    },
    {
      "name": "Affordable 45 Seater Bus Pune",
      "description": "Affordable 45 Seater Bus Pune focuses on delivering cost-effective transportation solutions for large groups without compromising on safety or comfort. Targeting schools, small businesses, families, and social groups, this service offers transparent pricing, clean and reliable buses, and professional drivers. Flexible rental options and easy booking processes make it a preferred choice for budget-conscious customers seeking quality transport."
    },
    {
      "name": "45 Seater Bus Online Booking Pune",
      "description": "45 Seater Bus Online Booking Pune provides a seamless and convenient digital platform for reserving 45 seater buses with instant confirmation and multiple payment options. Customers can customize routes, select pickup times, and manage bookings easily via their devices. With 24/7 customer support and transparent pricing, this online service ensures a smooth and stress-free booking experience for group travel across Pune."
    }
  ],
  "tableData": [
    ["45 Seater Bus On Rent in Pune", "45 Seater AC Bus Pune"],
    ["45 Seater Non AC Bus Pune", "45 Seater Luxury Bus Pune"],
    ["45 Seater Bus Hire Pune", "45 Seater Bus Rental Pune"],
    ["45 Seater Bus Hire in Baner", "45 Seater Bus Hire in Hinjewadi"],
    ["45 Seater Bus Hire in Pimpri", "45 Seater Bus Hire in Hadapsar"],
    ["45 Seater Bus for Wedding Pune", "45 Seater Bus for Corporate Pune"],
    ["45 Seater Bus for School Tour Pune", "45 Seater Volvo Bus Pune"],
    ["45 Seater Tourist Coach Pune", "45 Seater Bus Hire near Me Pune"],
    ["Affordable 45 Seater Bus Pune", "45 Seater Bus Online Booking Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "45 Seater Bus On Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd provides 45 seater bus rental services in Pune, ideal for large group travel, corporate outings, school trips, and event transportation."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Our 45 seater buses offer ample space, reclining seats, and air conditioning to ensure a comfortable journey for all passengers."
  },
  {
    "WhyChooseheading": "Regularly Serviced and Sanitized Buses",
    "WhyChoosedescription": "Each vehicle is well-maintained and sanitized after every trip to guarantee safety, hygiene, and reliability."
  },
  {
    "WhyChooseheading": "Clear and Competitive Pricing",
    "WhyChoosedescription": "We offer upfront pricing with no hidden fees, ensuring full transparency and value for your money."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, full-day, or custom trip options to meet your specific travel needs and schedule."
  },
  {
    "WhyChooseheading": "Experienced and Friendly Drivers",
    "WhyChoosedescription": "Our drivers are courteous, punctual, and trained to provide a safe and stress-free travel experience."
  },
  {
    "WhyChooseheading": "24/7 Assistance and Support",
    "WhyChoosedescription": "Our customer support team is available anytime to help with bookings, itinerary changes, or emergency assistance."
  },
  {
    "WhyChooseheading": "Seamless Booking Experience",
    "WhyChoosedescription": "Book your 45 seater bus quickly and easily online or by phone, with prompt service across Pune and nearby areas."
  }
]























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer 45 seater bus rental services in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides 45 seater buses on rent in Pune, suitable for large groups, corporate events, and tours.',
  },
  {
    question: 'How can I book a 45 seater bus in Pune with Amruta Travels?',
    answer: 'You can book conveniently through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the 45 seater buses in Pune?',
    answer: 'Our 45 seater buses are equipped with comfortable seating, air conditioning, spacious interiors, and essential safety features for a pleasant journey.',
  },
  {
    question: 'Are the drivers trained and experienced for 45 seater bus hires in Pune?',
    answer: 'Yes, all our drivers are professionally trained, courteous, and experienced in driving 45 seater buses safely around Pune.',
  },
  {
    question: 'Can 45 seater buses be hired for weddings, corporate events, tours, and airport transfers in Pune?',
    answer: 'Absolutely. Our 45 seater buses are ideal for weddings, corporate functions, sightseeing tours, airport transfers, and other group travel needs.',
  },
  {
    question: 'Is the 45 seater bus hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for 45 seater bus hire services in Pune to fit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for 45 seater bus hires?',
    answer: 'All buses are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure your well-being.',
  },
  {
    question: 'What are the payment options for 45 seater bus rental in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the 45 seater bus rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you anytime during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Prakash Nair',
    feedback: 'The 45 seater bus from Amruta Travels Pune was spacious and comfortable. The driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Sharma',
    feedback: 'Great service and well-maintained bus. The 45 seater bus was perfect for our corporate event in Pune.',
    rating: 5,
  },
];






























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "45 Seater Bus On Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/9.jpg",
  "description": "Book a 45 Seater Bus On Rent in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury buses for weddings, corporate events, school tours, and outstation travel. Reliable and affordable 45 seater bus rentals in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "14521"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4600",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/45-seater-bus-on-rent-in-pune"
  }
};







  return (
    <div>
<Helmet>
  <title>45 Seater Bus On Rent in Pune | AC & Luxury Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book 45 Seater Bus On Rent in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury buses for weddings, corporate events, school tours, and outstation travel. Affordable and reliable bus rentals in Pune."
  />
  <meta
    name="keywords"
    content="45 Seater Bus On Rent in Pune, 45 Seater AC Bus Pune, 45 Seater Non AC Bus Pune, 45 Seater Luxury Bus Pune, 45 Seater Bus Hire Pune, 45 Seater Bus Rental Pune, 45 Seater Bus Hire in Baner, 45 Seater Bus Hire in Hinjewadi, 45 Seater Bus Hire in Pimpri, 45 Seater Bus Hire in Hadapsar, 45 Seater Bus for Wedding Pune, 45 Seater Bus for Corporate Pune, 45 Seater Bus for School Tour Pune, 45 Seater Volvo Bus Pune, 45 Seater Tourist Coach Pune, 45 Seater Bus Hire near Me Pune, Affordable 45 Seater Bus Pune, 45 Seater Bus Online Booking Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fourfiveseaterbusonrentinpune;